import React, { Fragment } from 'react';
import { Row, Col, Table, Badge } from 'reactstrap';


const Insurance = ({ data }) => {
    console.log(data, 'insurance data')
    const insurance = data?.plan_services;

    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" >
                    <Table>
                        {/* <tbody>
                            <tr>
                                <th>Service</th>
                                <td className="text-right pr-5">{data.Company?.client_company_name || '-'}</td>
                            </tr>
                            <tr>
                                <th>Sum Assured</th>
                                <td className="text-right pr-5">{data.title || '-'}</td>
                            </tr>
                            <tr>
                                <th>Deductible</th>
                                <td className="text-right pr-5">{data.sales_category?.name || '-'}</td>
                            </tr>
                        </tbody> */}
                        <thead>
                            <tr>
                                <th>Service</th>
                                <th>Sum Assured</th>
                                <th>Deductible</th>
                            </tr>
                        </thead>
                        <tbody className="mtd-bg">
                            {insurance?.length > 0 ? (
                                insurance?.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item?.service?.title || '-'}</td>
                                        <td>{item?.sum_assured || '-'}</td>
                                        <td>{item?.deductible || '-'}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="text-center">No records found.</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default Insurance;